(function (root) {
  'use strict';
  // Installed prices and SRP rates: ONLINE PRICING CALCULATOR.xlsx, Sheet1 E4:K18.
  const sizes = ['2', '2.5', '3', '3.5', '4', '5'];
  const catalog = {
    heatPump: [
      { id: 'hp-standard', name: 'Essential Heat Pump', brand: 'Comfortmaker', model: '', efficiency: '15.2 SEER2', category: 'ESSENTIAL', prices: [9949, 10999, 12499, 11899, 12499, 13499], srpPerTon: 75 },
      { id: 'hp-enhanced', name: 'High Efficiency Heat Pump', brand: 'Trane', model: 'XR16', efficiency: '16 SEER2', category: 'ENHANCED', prices: [15599, 16799, 17299, 18399, 19399, 19799], srpPerTon: 75 },
      { id: 'hp-performance', name: 'Performance Heat Pump', brand: 'Hisense', model: 'HD PRO', efficiency: '18 SEER2', category: 'PERFORMANCE', prices: [14999, 16799, 16799, 19999, 19999, 20599], srpPerTon: 225 },
      { id: 'hp-pro', name: 'Performance Pro Heat Pump', brand: 'Trane', model: 'XV18', efficiency: '18 SEER2', category: 'PERFORMANCE PRO', prices: [20599, 20799, 20799, 21999, 21999, 23599], srpPerTon: 225 }
    ],
    furnace: [
      { id: 'gas-standard', name: 'Essential Dual Fuel', brand: 'Comfortmaker', model: '', efficiency: '15.2 SEER2', category: 'ESSENTIAL', prices: [10949, 11999, 13499, 12899, 13499, 14499], srpPerTon: 75 },
      { id: 'gas-enhanced', name: 'High Efficiency Dual Fuel', brand: 'Trane', model: 'XR16', efficiency: '16 SEER2', category: 'ENHANCED', prices: [16099, 17299, 17799, 18899, 19899, 19999], srpPerTon: 75 },
      { id: 'gas-pro', name: 'Performance Pro Dual Fuel', brand: 'Trane', model: 'XV18', efficiency: '18 SEER2', category: 'PERFORMANCE PRO', prices: [20499, 20999, 20999, 21599, 21599, 22299], srpPerTon: 225 }
    ],
    package: [
      { id: 'package-performance', name: 'Performance Package', brand: 'Trane', model: 'XL51', efficiency: '15.2 SEER2', category: 'PERFORMANCE', prices: [16999, 17599, 17999, 18679, 19399, 20699], srpPerTon: 150 },
      { id: 'package-pro', name: 'Performance Pro Package', brand: 'Hisense', model: 'Hi-Pak', efficiency: '18 SEER2', category: 'PERFORMANCE PRO', prices: [15999, 15999, 15999, 25399, 25399, 25499], srpPerTon: 225 }
    ]
  };
  const systems = Object.values(catalog).flat();
  const hearRebate = 8000;
  const promotionRate = 0.20;
  const memberRate = 0.05;
  const transparentRate = 0.05;
  const promotionDates = 'October 1 – November 30';
  function familyFor(state) {
    if (state.unit === 'package') return 'package';
    if (state.unit === 'split' && state.heat === 'gas') return 'furnace';
    return 'heatPump';
  }
  function systemsFor(state) { return catalog[familyFor(state)]; }
  function defaultSystemFor(state) { return systemsFor(state)[0]; }
  function systemFor(state) { return systemsFor(state).find(s => s.id === state.system) || defaultSystemFor(state); }
  function sizeFor(state) { return state.size === '1.5/2' ? '2' : state.size; }
  function quote(state) {
    const system = systemFor(state);
    const size = sizeFor(state);
    const index = sizes.indexOf(size);
    const regular = system.prices[index < 0 ? 2 : index];
    const promotion = state.path === 'promo' ? Math.round(regular * promotionRate) : 0;
    const instant = state.path === 'rebate' ? hearRebate : 0;
    const member = state.path === 'rebate' ? Math.round(regular * memberRate) : 0;
    const transparent = state.path === 'rebate' ? Math.round(regular * transparentRate) : 0;
    const utilityProvider = ['srp', 'aps', 'unknown'].includes(state.utilityProvider) ? state.utilityProvider : 'srp';
    const utilityStatus = utilityProvider === 'srp' && index >= 0 ? 'calculated' : utilityProvider === 'aps' ? 'none' : utilityProvider === 'unknown' ? 'provider-pending' : 'equipment-pending';
    const utility = utilityStatus === 'calculated' ? Math.round(Number(size) * system.srpPerTon) : 0;
    const savings = promotion + instant + member + transparent + utility;
    const due = regular - savings;
    return { system, regular, promotion, instant, member, transparent, utility, utilityMax: utility,
      utilityProvider, utilityStatus, srpPerTon: system.srpPerTon, tonnage: index < 0 ? null : Number(size),
      savings, savingsMax: savings, due, dueMin: due, eligible: index >= 0 };
  }
  const api = { sizes, catalog, systems, systemsFor, defaultSystemFor, systemFor, familyFor, hearRebate,
    promotionDates, promotionRate, memberRate, transparentRate, quote };
  if (typeof module !== 'undefined') module.exports = api;
  else root.ReeisPricing = api;
})(typeof window !== 'undefined' ? window : globalThis);
